// Visitor-facing conversion CTA shown on public profiles to logged-out
// viewers. The profile pages are publicly shareable (the whole point of the
// verified-profile loop), so a shared link lands anonymous visitors here with
// nothing to do — this turns that inbound social proof into a signup.
//
// Namespace import + runtime pick: @mindstonehq/ui ships TSX source whose named
// exports are not statically analyzable under the node/tsx ESM loader the
// self-running component test uses. Vite resolves either form.
import * as UI from "@mindstonehq/ui";
import { Link } from "react-router";
import { SparklesIcon } from "@heroicons/react/24/outline";

const ui = (UI as typeof UI & { default?: typeof UI }).Card
  ? UI
  : ((UI as typeof UI & { default?: typeof UI }).default ?? UI);
const { Button, Card, CardContent, CardHeader, CardTitle } = ui;

export default function ProfileVisitorCTA({
  displayName,
  username,
}: {
  displayName: string;
  username: string;
}) {
  const redirectUrl = encodeURIComponent(`/profile/${username}`);
  return (
    <Card id="profile-visitor-cta" className="border-primary/30 bg-muted/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <SparklesIcon className="size-5 text-muted-foreground" />
          Get your own verified AI profile
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3 text-sm text-muted-foreground">
        <p>
          {displayName} built this by learning and showing up at Mindstone
          events. Create your free profile to track what you learn and prove
          your AI skills to anyone.
        </p>
        <Button asChild size="sm" className="self-start">
          <Link to={`/signup?redirectUrl=${redirectUrl}`}>
            Create your free profile
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
